import { PageHeader, EmptyState } from '../components/UI';

export function PortalPlaceholder({ title, description }: { title: string; description: string }) {
  return <section className="portal-page"><PageHeader title={title} description={description} /><EmptyState title="Ready for live data" text="This route is protected and will activate after Supabase records are created." /></section>;
}
